import featureEnabled from 'shared/helper/feature';

/**
 * Guards everything to do with verifying a new account's email address.
 *
 * Megatron keys the same flag: with it off nothing issues a token, no login is
 * ever refused for want of verification, and none of the screens below can be
 * reached, so the sign-up flow behaves exactly as it did before.
 * @see EmailVerificationService::FEATURE_FLAG
 */
export var EMAIL_VERIFICATION_FLAG = 'users_email_verification';
export var emailVerificationEnabled = function emailVerificationEnabled() {
  return featureEnabled(EMAIL_VERIFICATION_FLAG);
};
export default emailVerificationEnabled;